import { useEffect } from 'react'
import { PolicyPage, PageShell } from './PolicyPage'
export default function SafetyHygiene() {
  useEffect(() => { document.title = 'Safety & Hygiene — SYNINN' }, [])
  return <PolicyPage title="Safety & Hygiene" subtitle="Our commitment to safe dining" sections={[
    { heading: 'Our responsibility', text: 'SYNINN is a booking platform and does not directly operate restaurants. We do not conduct hygiene inspections.' },
    { heading: 'Restaurant responsibility', text: 'All restaurants on SYNINN are responsible for maintaining their own hygiene standards and FSSAI compliance.' },
    { heading: 'Reporting', text: 'If you have a hygiene or safety concern, please raise a dispute in the app or email support@syninn.com.' },
  ]} />
}